import { TCourseInfo } from 'types/apis/mypage';
import { UserRoleType } from 'types/apis/auth';

export enum MypageCheckPasswordFormFields {
  Password = 'password',
}

export enum MypageInfoFormFields {
  Name = 'name',
  LoginId = 'loginId',
  Email = 'email',
  PhoneNum = 'phoneNum',
  RegistrationStatus = 'registrationStatus',
  SchoolYear = 'schoolYear',
  StudentToCourseList = 'studentToCourseList',
  CourseNameList = 'courseNameList',
}

export enum RegistrationStatusType {
  재학 = '재학',
  휴학 = '휴학',
}

export enum SchoolYearType {
  SchoolYear1 = '1학년',
  SchoolYear2 = '2학년',
  SchoolYear3 = '3학년',
}

export type TMypageCheckPasswordForm = {
  [MypageCheckPasswordFormFields.Password]: string;
};

export type TMypageInfoForm = {
  [MypageInfoFormFields.Name]: string;
  [MypageInfoFormFields.LoginId]?: string;
  [MypageInfoFormFields.Email]: string;
  [MypageInfoFormFields.PhoneNum]: string;
  [MypageInfoFormFields.RegistrationStatus]?: UserRoleType | null;
  [MypageInfoFormFields.SchoolYear]?: string;
  [MypageInfoFormFields.StudentToCourseList]?: TCourseInfo[];
  [MypageInfoFormFields.CourseNameList]?: string[];
};
